// In TopicsContext.tsx
import React from 'react';
import { TopicsEntity } from './TopicsEntity';

type TopicsContextType = [TopicsEntity[], React.Dispatch<React.SetStateAction<TopicsEntity[]>>];

export const TopicsContext = React.createContext<TopicsContextType>([[], () => {}]);
